import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AddressDetailsPage } from './address-details.page';

const routes: Routes = [
  {
    path: '',
    component: AddressDetailsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class AddressDetailsPageRoutingModule {}
